import React from 'react';
import { WalletMultiButton } from '@solana/wallet-adapter-react-ui';
import { Dice5 as Dice, Coins, Trophy } from 'lucide-react';

const WelcomeScreen = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] max-w-4xl mx-auto p-6">
      {/* Hero Section */}
      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold mb-4 bg-gradient-to-r from-primary-400 to-accent-400 bg-clip-text text-transparent">
          Welcome to Roll The Dice!
        </h1>
        <p className="text-xl text-gray-300 mb-8">
          Test your luck and win big with our exciting dice game
        </p>
        
        {/* Connect Wallet Button */}
        <div className="mb-12">
          <WalletMultiButton className="px-8 py-4 bg-accent-500 hover:bg-accent-600 rounded-xl transition-colors text-lg" />
        </div>
      </div>

      {/* Features Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 w-full">
        <div className="bg-gray-800/50 p-6 rounded-xl border border-gray-700/30">
          <div className="flex items-center gap-3 mb-4">
            <div className="p-3 bg-primary-600/20 rounded-lg">
              <Dice className="w-6 h-6 text-primary-400" />
            </div>
            <h3 className="text-lg font-semibold text-primary-400">Simple to Play</h3>
          </div>
          <p className="text-gray-300">
            Roll the dice and match winning combinations to earn rewards
          </p>
        </div>

        <div className="bg-gray-800/50 p-6 rounded-xl border border-gray-700/30">
          <div className="flex items-center gap-3 mb-4">
            <div className="p-3 bg-accent-600/20 rounded-lg">
              <Coins className="w-6 h-6 text-accent-400" />
            </div>
            <h3 className="text-lg font-semibold text-accent-400">Burn $ROLL</h3>
          </div>
          <p className="text-gray-300">
            Use $ROLL tokens to play and get a chance to win $MONOPOLY
          </p>
        </div>

        <div className="bg-gray-800/50 p-6 rounded-xl border border-gray-700/30">
          <div className="flex items-center gap-3 mb-4">
            <div className="p-3 bg-secondary-600/20 rounded-lg">
              <Trophy className="w-6 h-6 text-secondary-400" />
            </div>
            <h3 className="text-lg font-semibold text-secondary-400">Win Big</h3>
          </div>
          <p className="text-gray-300">
            Growing reward pool means bigger potential winnings
          </p>
        </div>
      </div>
    </div>
  );
};

export default WelcomeScreen;
